import {useEffect, useState} from 'react';
import {WindowWidth} from './WindowWidth';


export function useMobile(minWidth = WindowWidth.Mobile, boolean = true): boolean {
  const [mobile, setMobile] = useState(boolean);

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${minWidth}px)`);
    setMobile(!media.matches);
    const handler = (e: MediaQueryListEvent): void => setMobile(!e.matches);
    media.addListener(handler);
    return () => {
      media.removeListener(handler);
    };
  }, [minWidth]);

  return mobile;
}
